import { FormInputBlock } from './form-input-block.js'
import type { EventType, HtmlType, NameAndType } from '../../types.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'

@jsonClass('DatePickerBlock')
export class DatePickerBlock extends FormInputBlock {
	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Label',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	labelCode = new TextOrExpression_assumeExpression('', 'T')

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Binding',
		codeLanguage: 'ts',
		tsReturnType: () => 'Date',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => true,
	})
	bindingCode = new Expression()

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Minimum date',
		codeLanguage: 'ts',
		tsReturnType: () => 'Date',
		editorSize: 'singleline',
		isBinding: false,
	})
	minDateCode = new Expression()

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Maximum date',
		codeLanguage: 'ts',
		tsReturnType: () => 'Date',
		editorSize: 'singleline',
		isBinding: false,
	})
	maxDateCode = new Expression()

	canAcceptVariableString = (variable: NameAndType) => variable.type == 'Date'
	acceptVariableString = (variable: NameAndType) =>
		(this.bindingCode = new Expression(variable.name))

	constructor(init: Partial<DatePickerBlock> = {}) {
		super()
		this.exampleText = '31.12.2020'
		this.init(init)
	}

	producePreview(): HtmlType {
		return `<input tabindex="-1" value="${this.exampleText || '31.12.2020'}">`
	}

	getEditorCategory(): string {
		return 'Core'
	}

	get allowedEventTypes(): EventType[] {
		return [{ name: 'dateChange' }]
	}

	getValidationValueType(): string {
		return 'Date'
	}
}
